import { render, staticRenderFns } from "./InboxWindowMessages.vue?vue&type=template&id=2425f00e"
import script from "./InboxWindowMessages.vue?vue&type=script&lang=ts"
export * from "./InboxWindowMessages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2425f00e')) {
      api.createRecord('2425f00e', component.options)
    } else {
      api.reload('2425f00e', component.options)
    }
    module.hot.accept("./InboxWindowMessages.vue?vue&type=template&id=2425f00e", function () {
      api.rerender('2425f00e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/InboxWindowMessages.vue"
export default component.exports